import { faqData } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于汗汗漫画的常见疑问，这里都有解答</p>
        </div>
        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl p-5 border border-background-200/60"
            >
              <h3 className="font-heading font-bold text-foreground-900 text-sm mb-2 flex items-start gap-2">
                <span className="text-accent-500 shrink-0 mt-0.5">
                  <i className="ri-question-line text-sm"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-6">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}